import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { tap, catchError, finalize } from 'rxjs/operators';
import { ToastService } from '../../services/toast/toast.service';
import { TranslateService } from '../../utilities/translate/translate.service';
import * as Sentry from '@sentry/browser';

/**
 * Interceptor class for the loader.
 */
@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

  /** Backdrop element. */
  private _backdrop: HTMLElement;

  /** Snackbar reference. */
  private _loadingToast: MatSnackBarRef<SimpleSnackBar>;

  constructor(
    private toastService: ToastService,
    private translateService: TranslateService
  ) {
    // Backdrop is currently disabled.
    // To enable, also uncomment the two lines in the show/dismiss loader methods.
    // this._createBackdrop();
  }

  /**
   * Interceptor.
   *
   * Intercepts the HTTP calls from the API and shows a loading message.
   *
   * @param req HTTP request.
   * @param next HTTP handler.
   * @returns A HttpEvent observable with the current http stream.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._showLoader();
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this._dismissLoader();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.toastService.open(this.translateService.get('unknownerror'));
        Sentry.captureException(error);
        return throwError(error);
      }),
      finalize(() => {
        // @todo: Dismiss loader here.
      })
    );
  }

  /**
   * Create backdrop element.
   *
   * The backdrop element is used to prevent additional clicks
   * during running queries.
   */
  private _createBackdrop(): void {
    this._backdrop = document.createElement('div');
    this._backdrop.classList.add('backdrop');
    this._backdrop.classList.add('backdrop-interceptor');
    document.body.append(this._backdrop);
  }

  /**
   * Dismiss loader.
   */
  private _dismissLoader(): void {
    // this._backdrop.classList.remove('active');
    this._loadingToast.dismiss();
  }

  /**
   * Show loader.
   */
  private _showLoader(): void {
    this._loadingToast = this.toastService.open(
      this.translateService.get('pleasewait'),
      null,
      { duration: 9999, horizontalPosition: 'left' }
    );
    // this._backdrop.classList.add('active');
  }
}
